import React, { Component } from "react";

import { Alert } from "reactstrap";

import Login from "../components/Home/Login";
import CheckedIcon from "../assets/img/checked.svg";

class Home extends Component {
  state = {
    alertSucess: false,
  };

  handleSucess = async () => {
    await this.setState({ alertSucess: true });
    await setTimeout(() => {
      this.setState({ alertSucess: false });
    }, 1500);
  };

  render() {
    return (
      <div className="container">
        <Alert
          color="success"
          isOpen={this.state.alertSucess}
          style={{ position: "absolute", margin: "0" }}
        >
          Email enviado com sucesso
          <img
            alt="sucesso"
            src={CheckedIcon}
            style={{ height: "25px", weight: "25px", paddingLeft: "5px" }}
          />
        </Alert>
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-8 col-lg-5 mb-3">
            <Login handleSucess={this.handleSucess} />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js